export default {
  BusinessPurchaseSupplierShop: {
    header: {
      code: 'Supplier code',
      name: 'Supplier name',
      package: 'Include Packaging',
      free: 'Free Shipping',
      commodityCode1: 'Supplier Product Code',
      sku: 'Supplier SKU Code',
      commodityCode2: 'Product Code',
      skuCode: 'SKU'
    },
    export: {
      startData: 'Start Date',
      endData: 'End Date',
      excelImport: 'Import',
      modify: 'Edit',
      export: 'Export',
      rules: 'Excel Import Supplier Rule Explanation',
      p1: 'If the corresponding supplier product information for the supplier name and product code already exists, it will be overwritten during import; otherwise, a new record will be added.',
      p2: 'Import template, click to download',
      title: 'Supplier Product Import Template',
      productExport: 'Export Supplier Product',
      p3: 'The imported Excel file must have a title row, with red columns being required; please set the columns in text format, otherwise type conversion errors may occur.',
      p4: 'Supported file formats: csv, xls, xlsx. The file size for a single import cannot exceed 128MB and the number of data rows cannot exceed 60,000. If it does, please divide into multiple imports.',
      day: 'Day'
    },

    table: {
      picture: 'Image',
      spuCode: 'Product Code',
      name: 'Product Name',
      sku: 'SKU',
      skuName: 'SKU Name',
      supplierCode: 'Supplier code',
      supplierName: 'Supplier name',
      taxUnitPrice: 'Tax-Inclusive Purchase Price',
      unitPrice: 'Exclusive of Tax Purchase Price',
      taxRate: 'Tax Rate',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
      package: 'Include Packaging',
      shipping: 'Free Shipping',
      minQty: 'Minimum Purchase Quantity',
      week: 'Delivery Cycle',
      remark: 'Remark',
      updateDate: 'Modification Time'
    },

    dataForm: {
      title: 'Supplier Information',
      titleBtn: 'Operation Log',
      supplier: 'Supplier',
      week: 'Delivery Cycle',
      day: 'Day',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
      taxUnitPrice: 'Tax-Inclusive Purchase Price',
      unitPrice: 'Exclusive of Tax Purchase Price',
      taxRate: 'Tax Rate',
      minQty: 'Minimum Purchase Quantity',
      package: 'Include Packaging',
      shipping: 'Free Shipping',
      remark: 'Remark',
      productInformation: 'Related System Product Information',
      picture: 'Product Image',
      spuCode: 'Product Code',
      name: 'Product name',
      sku: 'SKU',
      skuName: 'SKU Name',
      addCommodity: 'Add General Product',
      edit: 'Edit',
      add: 'New',
      supplierId: 'Please Select a Supplier',
      taxUnitPriceRule: 'Please Enter the Tax-Inclusive Purchase Price',
      log: 'Product Log',
      msgError: 'Please Select Related System Product'
    }
  }
};
